import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{staticClass:"d-flex justify-center",attrs:{"row":"","fill-height":"","wrap":""}},[_c('banner-left',{staticClass:"mr-0 ml-0 mb-0 full",attrs:{"title":"Device Reputation at Speed","subText":"Confirmed Fraud in Milliseconds.","image":"/img/tu-credit-three.jpg","buttons":_vm.dvButtons,"actColor":"accent"}}),_c('product-banner',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }